import Service, { inject as service } from "@ember/service"
import { omit } from "lodash-es"
import type EmberStore from "./ember-store"

export default class CardStackTemplateUpdater extends Service {
  @service("ember-store") declare store: EmberStore

  subscriptions: Record<string, string> = {}

  subscribe(cardStackId: string, cardStackTemplateId: string) {
    this.subscriptions[cardStackId] = cardStackTemplateId
  }

  unsubscribe(cardStackId: string) {
    this.subscriptions = omit(this.subscriptions, cardStackId)
  }
}
